// extracted by mini-css-extract-plugin
module.exports = {"button":"buttons_button__bw33U","light":"buttons_light__Q01p3","label":"buttons_label__2iNUf"};